<template>
  <div>
    <div class="banner777">
      <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082901561979.jpg"></el-image>
      <div class="cover">
        <h1>橡胶产品</h1>
        <div class="subtitle">绿色橡胶</div>
      </div>
    </div>
    <div class="b-item">
      <el-row>
        <el-col :span="10">
          <div class="img" style="display: flex; justify-content: flex-start">
            <el-image src="/img/c1.jpg"></el-image>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="dc">
            <div class="y1">浓缩胶乳（Concentrated Latex）</div>
            <div style=" margin-top: 30px" class="y2">· 60%浓缩胶乳 – 高氨High Ammonia</div>
            <div class="y2">· 60%浓缩胶乳 – 低氨Low Ammonia</div>
            <div class="y2">· 60%浓缩胶乳 – 中氨Medium Ammonia</div>
            <div class="y2">· 60%浓缩胶乳 – 双次离心Double Centrifuge</div>
            <div class="y2">包装方式：太空包/桶装</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="b-item">
      <el-row>
        <el-col :span="14">
          <div class="dc">
            <div class="y1">标准胶 (Technically Specified Rubber)</div>
            <div style=" margin-top: 30px" class="y2">泰国标胶系列</div>
            <div class="y2">· STR 10/20/9720· 混合胶（Mixture Rubber）· 复合胶 (Compound Rubber)· CV恒黏胶 (Constant Viscosity
              Natural Rubber)
            </div>
            <div class="y2">印尼标胶系列</div>
            <div class="y2">· SIR 10/20· 混合胶（Mixture Rubber）</div>
            <div class="y2">缅甸标胶系列</div>
            <div class="y2">· MSR 包装方式：木托盘/塑料托盘/金属箱/散包</div>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="img" style="display: flex; justify-content: flex-end">
            <el-image src="/img/c2.jpg"></el-image>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="b-item">
      <el-row>
        <el-col :span="10">
          <div class="img" style="display: flex; justify-content: flex-start">
            <el-image src="/img/c3.jpg"></el-image>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="dc">
            <div class="y1">烟片胶（Ribbed Smoked Sheet）</div>
            <div style=" margin-top: 30px" class="y2">· 1号烟片RSS1 · 2号烟片RSS2· 3号烟片RSS3· 4号烟片RSS4· 5号烟片RSS5</div>
            <div class="y2">包装方式：</div>
            <div class="y2">· 111.11公斤散包</div>
            <div class="y2">· 33.33公斤热缩包装，木托盘/金属托盘包装</div>
            <div class="y2">· 35公斤热缩包装，木托盘/金属托盘包装</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index"
}
</script>

<style scoped>
@import url("Index.css");
</style>